import { render, staticRenderFns } from "./confirmacao-email.vue?vue&type=template&id=e8a63950&scoped=true&"
import script from "./confirmacao-email.vue?vue&type=script&lang=js&"
export * from "./confirmacao-email.vue?vue&type=script&lang=js&"
import style0 from "./confirmacao-email.vue?vue&type=style&index=0&id=e8a63950&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8a63950",
  null
  
)

export default component.exports